import { render, staticRenderFns } from "./NotesDetails.vue?vue&type=template&id=9c371204&scoped=true&"
import script from "./NotesDetails.vue?vue&type=script&lang=js&"
export * from "./NotesDetails.vue?vue&type=script&lang=js&"
import style0 from "./NotesDetails.vue?vue&type=style&index=0&id=9c371204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c371204",
  null
  
)

export default component.exports